import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Table, TableContainer } from "@mui/material";
import { IChannel, ISelection, socialMediaTip } from "./helper";
import { IVideo } from "../../admin/videos/hooks/useFetchVideos";
import { VideoCard } from "../../../components/videoSection/VideoCard";
import { UploadableVideoCard } from "../../../components/videoSection/VideoUpload";
import { MediaChannelTable } from "./mediaChannelTable";
import { TableHeader } from "./mediaChannelTable/TableHeader";
import { usePortalPath } from '../../../hooks/usePortalPath'

interface Props {
  group: any;
  channel: IChannel;
  files: Array<IVideo>;
  selections: Array<ISelection>;
  setSelections: (data: Array<any>) => void;
}

export const MediaTabView: FC<Props> = (props) => {
  const navigate = useNavigate();
  const { p } = usePortalPath();
  const { files, channel } = props;

  return (
    <Box className="flex flex-col gap-4 mt-4">
      {files.map((video) => {
        const tip = channel.name === "Social" && video.aspect_ratio === "16x9";
        return (
          <Box className="flex flex-col gap-2">
            {tip && socialMediaTip}
            <Box
              className="flex flex-col xl:flex-row"
              gap={6}
              key={`channel-video-${video.id}`}
            >
              <Box className="w-[300px] px-2">
                <UploadableVideoCard
                  video={video}
                  project={(video as any).project}
                  refetch={() => undefined}
                >
                  {/* drag-only: embed rows carry no project */}
                  {() => (
                    <VideoCard
                      video={video}
                      variant="browse"
                      onOpen={() => navigate(p(`/videos/tdc?video=${video.id}`))}
                    />
                  )}
                </UploadableVideoCard>
              </Box>
              <Box className="w-full px-2">
                {channel?.subChannels.length > 0 && (
                  <TableContainer className="border rounded-2xl border-border-token p-3 px-4 overflow-auto">
                    <Table sx={{ minWidth: 700 }} aria-label="simple table">
                      <TableHeader />
                      <MediaChannelTable video={video} {...props} />
                    </Table>
                  </TableContainer>
                )}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
